const BYTES_PRODUCT_NAME = 'Coinbase Bytes';
const BYTES_SUBSCRIBE_LOG_EVENT = 'bytes_subscribe';
export { BYTES_PRODUCT_NAME, BYTES_SUBSCRIBE_LOG_EVENT };
//# sourceMappingURL=consts.js.map
